import { useEffect, useRef } from "react";

/** Ctrl+S (Cmd+S on Mac) runs the editor's save instead of the browser's Save Page. */
export function useSaveShortcut(handler, enabled = true) {
  const ref = useRef(handler);
  ref.current = handler;
  useEffect(() => {
    if (!enabled) return undefined;
    const onKey = (e) => {
      if ((e.ctrlKey || e.metaKey) && !e.shiftKey && !e.altKey && e.key.toLowerCase() === "s") {
        e.preventDefault();
        if (!e.repeat) ref.current();
      }
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [enabled]);
}

export const SAVE_HINT = /Mac|iPhone|iPad/.test(navigator.platform || "") ? "Cmd+S" : "Ctrl+S";
